export default "__VITE_ASSET__d0b086e7__"